import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button as RbButton, Form } from 'react-bootstrap';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const uuid = require('uuid');

const ServerRequest = require('../../actions/request');
const ActivityActions = require('../../actions/ActivityActions');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    novaActId: PropTypes.string.isRequired,
    closeHandler: PropTypes.func.isRequired,
    importStacks: PropTypes.array,
};

const defaultProps = {
    importStacks: [],
};

class StackImportMergeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            devImportStack: '',
            devImportError: '',
            devImportActivityId: '',
            devImportActivityVersion: '',
        };

        this.setImportStack = this.setImportStack.bind(this);
        this.setImportActivity = this.setImportActivity.bind(this);
        this.setImportVersion = this.setImportVersion.bind(this);
        this.doImport = this.doImport.bind(this);
    }

    // import dev tool functions
    setImportStack(stackName) {
        this.setState({
            devImportStack: stackName,
            devImportError: '',
        });
    }

    setImportActivity(e) {
        this.setState({
            devImportActivityId: e.target.value,
            devImportError: '',
        });
    }

    setImportVersion(e) {
        this.setState({
            devImportActivityVersion: e.target.value,
            devImportError: '',
        });
    }

    doImport() {
        ServerRequest.makeRequest('/authoring/import_activity_merge', 'POST', JSON.stringify({
                local_activity_id: this.props.novaActId,
                stack: this.state.devImportStack,
                activity_id: this.state.devImportActivityId,
                version:  this.state.devImportActivityVersion,
            }))
            .then((resActivityId) => {
                console.log("import complete.");
                ActivityActions.getActivity(uuid.v4, { activityId: resActivityId });
                this.props.closeHandler();
            })
            .catch((err) => {
                this.setState({
                    devImportError: err.responseText
                });
            });
    }

    render() {
        if (!this.props.importStacks || this.props.importStacks.length === 0) {
            return null;
        }

        return (
            <Modal
                className='import-modal'
                show
                autoFocus
                keyboard
                enforceFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Dev Import (EXPERIMENTAL)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox
                        error={this.state.devImportError ? { message: this.state.devImportError } : null}
                    />
                    <Form>
                        <Form.Group>
                            <Wrapper className='AriaMenuButton inline-block' onSelection={this.setImportStack}>
                                <Button className="AriaMenuButton-trigger flat-button primary btn-width2">
                                    {this.state.devImportStack || 'select stack'}
                                </Button>
                                <Menu>
                                    <ul className='AriaMenuButton-menu'>
                                        {this.props.importStacks.map((stackName) =>
                                            <li className='AriaMenuButton-menuItemWrapper' key={stackName}>
                                                <MenuItem className="AriaMenuButton-menuItem" value={stackName} text={stackName}>
                                                    {stackName}
                                                </MenuItem>
                                            </li>
                                        )}
                                    </ul>
                                </Menu>
                            </Wrapper>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Nova Activity ID</Form.Label>
                            <Form.Control
                                type="text"
                                htmlSize={40}
                                maxLength={40}
                                onChange={this.setImportActivity}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Version</Form.Label>
                            <Form.Control
                                htmlSize={10}
                                maxLength={10}
                                onChange={this.setImportVersion}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <RbButton onClick={this.doImport}>Import</RbButton>
                </Modal.Footer>
            </Modal>
        );
    }
}

StackImportMergeModal.propTypes = propTypes;
StackImportMergeModal.defaultProps = defaultProps;

export default StackImportMergeModal;